import { render, staticRenderFns } from "./medicalapparatus.vue?vue&type=template&id=f82b4900&scoped=true&"
import script from "./medicalapparatus.vue?vue&type=script&lang=js&"
export * from "./medicalapparatus.vue?vue&type=script&lang=js&"
import style0 from "./medicalapparatus.vue?vue&type=style&index=0&id=f82b4900&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82b4900",
  null
  
)

export default component.exports